import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  userService = inject(UserService);
  router = inject(Router);


  async canActivate() {
    try {
      await this.userService.ensureUserLoaded();
      return true;
    } catch (e) {
      await this.router.navigate(['/login']);
      return false;
    }
  }
}
